<template>
  <div class="card card-user">
    <div class="image">
      <ImageLoader :picture="store.picture" alt="..." />
    </div>
    <div class="card-content" v-if="store">
      <div class="author">
        <h4 class="title">{{ store.name }}
          <br>
          <a href="#" v-if="company">
            <small>{{ company.name }}</small>
          </a>
        </h4>
      </div>
      <p class="description text-center">
        {{store.info}}
      </p>
    </div>
    <hr>
    <div class="text-center" v-if="store">
      <div class="row">
        <div class="col-md-10 col-md-offset-1">
          <h5>{{store.address}}
            <br>
            <small>Adresse</small>
          </h5>
        </div>
        <div class="col-md-10 col-md-offset-1">
          <h5>{{store.email}}
            <br>
            <small>Email</small>
          </h5>
        </div>
        <div class="col-md-10 col-md-offset-1">
          <h5>{{store.phoneNumber}}
            <br>
            <small>Téléphone</small>
          </h5>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import ImageLoader from '@/components/Utils/Image.vue'
  import { mapGetters } from 'vuex'

  export default {
    props: {
      company: {
        type: Object,
        required: true
      },
      store: {
        type: Object,
        required: true
      }
    },
    components: {
      ImageLoader
    }
  }

</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/Store/Card.vue